import * as turf from '@turf/turf';

export function sortByDistance(pois) {
	return pois.sort((a, b) => a.distance - b.distance);
}

export function calculateDistances(center, pois) {
	const centerPoint = turf.point([center.longitude, center.latitude]);

	return pois.map((p) => {
		const newP = {
			...p,
			distance: turf.distance(turf.point([p.lon || p.center.lon, p.lat || p.center.lat]), centerPoint),
		};
		return newP;
	});
}
